import Calendar from "images/ic_calendar.svg";
import { useAppSelector } from "../../../../../util/store-types";
import { isActiveMembership } from "helpers/membership-helpers";

export default function ReservePromoBanner() {
  const cmsContent = useAppSelector(state => state.smartComponentState?.PDPContent?.data);
  const isActiveMember = useAppSelector(state => isActiveMembership(state.membershipState));

  if (!cmsContent?.reserve || !cmsContent?.reserve?.promoCode) {
    return null;
  }

  const hed = cmsContent?.reserve?.hed;
  const copy = cmsContent?.reserve?.copy;
  const copyTwo = cmsContent?.reserve?.copyTwo;
  const promoCode = cmsContent?.reserve?.promoCode;

  return (
    <div
      className={`h-full p-3 rounded-md text-sm ${
        isActiveMember ? "bg-wine100" : "bg-pink border border-lighterGray shadow-[0px_4px_8px_0px_rgba(0,0,0,0.10)]"
      } `}
      data-test-id="reserve-promo-banner">
      <div className="flex items-center mb-1">
        <Calendar />
        <p className="ml-2 font-semibold">{hed}</p>
      </div>
      <div className="ml-8">
        <span>{copy} </span>
        <span className="font-semibold">{promoCode} </span>
        <span>{copyTwo}</span>
      </div>
    </div>
  );
}
